var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"top-option-block"},[_c('router-link',{staticClass:"link",attrs:{"to":"/customer"}},[_vm._v("กลับไปหน้าค้นหา")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }